// @flow
import React from "react"
import { compose } from "react-apollo"
import { Prompt } from "react-router-dom"
import { Helmet } from "react-helmet"
import AttractLoopForm from "./AttractLoopForm"
import queries from "./queries"
import Loader from "../UI/Loader"
import type { AttractLoopFormViewProps } from "./types"
import handleSubmit from "./handleSubmit"
import { confirmDeletePath } from "./helpers"

type State = { isBlocking: boolean }

class AttractLoopFormView extends React.Component<
  AttractLoopFormViewProps,
  State
> {
  constructor(props) {
    super(props)
    this.state = { isBlocking: false }
  }

  handleChange(e) {
    this.setState(() => ({ isBlocking: true }))
  }

  componentDidUpdate(prevProps, prevState) {
    const { details } = this.props
    if (
      prevProps.details &&
      prevProps.details.loading &&
      details &&
      !details.loading
    ) {
      this.setState(() => ({ isBlocking: false }))
    }
  }

  render() {
    const {
      createAttractLoop,
      updateAttractLoop,
      history: { push },
      match: { params: { id } },
      details
    } = this.props
    const { isBlocking } = this.state
    return (
      <div>
        <Helmet>
          <title>
            {`Attract Loops - ${details
              ? `${details.attractLoop ? details.attractLoop.title : "Editing"}`
              : "New"}`}
          </title>
        </Helmet>
        <Prompt
          when={isBlocking}
          message={location =>
            `Are you sure you want to leave this form and lose any unsaved changes?`}
        />
        <Loader loading={details ? details.loading : false}>
          <AttractLoopForm
            loading={details ? details.loading : true}
            initialValues={details ? details.attractLoop : {}}
            onSubmit={handleSubmit(
              id,
              createAttractLoop,
              updateAttractLoop,
              () => {
                this.setState(() => ({ isBlocking: false }))
                push("/admin/attract-loops")
              }
            )}
            onChange={e => this.handleChange(e)}
            handleCancel={event => {
              event.preventDefault()
              push("/admin/attract-loops")
            }}
            handleDelete={async event => {
              event.preventDefault()
              await this.setState(() => ({
                isBlocking: false
              }))
              push(confirmDeletePath(id))
            }}
            isNew={id ? false : true}
            id={id}
          />
        </Loader>
      </div>
    )
  }
}

export default compose(
  queries.withAttractLoopFormDetails,
  queries.mutateCreateAttractLoop,
  queries.mutateUpdateAttractLoop
)(AttractLoopFormView)



// WEBPACK FOOTER //
// ./src/AttractLoops/AttractLoopFormView.js